import { render, staticRenderFns } from "./ButtonPermission.vue?vue&type=template&id=74b3f038"
import script from "./ButtonPermission.vue?vue&type=script&lang=js"
export * from "./ButtonPermission.vue?vue&type=script&lang=js"
import style0 from "./ButtonPermission.vue?vue&type=style&index=0&id=74b3f038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports